import { routing } from "../../routing.js";
import { Query, SortOrder } from "../../types/index.js";
export function createClient(api) {
  async function list({
    limit,
    offset,
    search,
    sortOrder
  } = {}) {
    return api.get(routing.newsroomsUrl, {
      query: {
        limit,
        offset,
        search,
        sort: SortOrder.stringify(sortOrder)
      }
    });
  }
  async function search(options = {}) {
    const {
      query,
      limit,
      offset,
      search,
      sortOrder
    } = options;
    // TODO: Introduce dedicated Search POST API
    return api.get(routing.newsroomsUrl, {
      query: {
        query: Query.stringify(query),
        limit,
        offset,
        search,
        sort: SortOrder.stringify(sortOrder)
      }
    });
  }
  async function get(id) {
    const {
      newsroom
    } = await api.get(`${routing.newsroomsUrl}/${id}`);
    return newsroom;
  }
  async function create(payload) {
    const {
      newsroom
    } = await api.post(routing.newsroomsUrl, {
      payload
    });
    return newsroom;
  }
  async function update(id, payload) {
    const {
      newsroom
    } = await api.patch(`${routing.newsroomsUrl}/${id}`, {
      payload
    });
    return newsroom;
  }
  async function archive(id) {
    const {
      newsroom
    } = await api.post(`${routing.newsroomsUrl}/${id}/archive`);
    return newsroom;
  }
  async function unarchive(id) {
    const {
      newsroom
    } = await api.post(`${routing.newsroomsUrl}/${id}/unarchive`);
    return newsroom;
  }
  async function doDelete(id) {
    return api.delete(`${routing.newsroomsUrl}/${id}`);
  }
  async function takeOffline(id) {
    const {
      newsroom
    } = await api.post(`${routing.newsroomsUrl}/${id}/offline`);
    return newsroom;
  }
  async function takeOnline(id) {
    const {
      newsroom
    } = await api.post(`${routing.newsroomsUrl}/${id}/online`);
    return newsroom;
  }
  return {
    list,
    search,
    get,
    create,
    update,
    archive,
    unarchive,
    delete: doDelete,
    takeOnline,
    takeOffline
  };
}